import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {ModalService} from '../../shared/services/modal.service';
import {AdminService} from '../../shared/services/admin.service';
import {alertMessages, AlertService} from '../../shared/services/alert.service';
import {ModalAdminEducationLevelComponent} from '../admin-education-levels/modal-admin-education-level/modal-admin-education-level.component';
import {catchError} from 'rxjs/operators';
import {empty} from '../../functions';
import {ModalAdminEducationprogramComponent} from './modal-admin-educationprogram/modal-admin-educationprogram.component';

@Component({
    selector: 'app-admin-educations',
    templateUrl: './admin-educations.component.html',
    styleUrls: ['./admin-educations.component.scss'],
    standalone: false
})
export class AdminEducationsComponent implements OnInit {

  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: 'Code',
        name: 'code',
        type: 'text'
      },
      {
        header_name: 'Title',
        name: 'title',
        type: 'text'
      },
      {
        header_name: 'International title',
        name: 'internationalTitle',
        type: 'text'
      }
    ],
    endpoint: 'educationprogram',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject()

  };

  /**
   * Constructor
   *
   * @param modal
   * @param adminService
   * @param alertService
   */
  constructor(public modal: ModalService,
              public adminService: AdminService,
              private alertService: AlertService) { }

  /**
   * Ng on init
   */
  ngOnInit(): void {


  }


  /**
   * Add a new education level
   *
   * Uses a modal
   */
  addEducationProgram() {

    const modalOptions = {
      backdrop: 'static',
      size: 'xl'
    };

    const data = {
      entity : {
        name: '',
      }
    };

    this.modal.Modal(ModalAdminEducationprogramComponent, '','', data, [], modalOptions).then( (result) => {

      if (result === true) {
        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });

  }

  /**
   * Update education level
   *
   * @param $data
   */
  updateEducationProgram($data:any) {

    const modalOptions = {
      backdrop: 'static',
      size: 'xl'
    };

    const data = {
      entity: $data
    };

    this.modal.Modal(ModalAdminEducationprogramComponent, '', '', data, [], modalOptions).then( (result) => {

      if (result === true) {
        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });

  }

  /**
   * Delete education level
   *
   * @param $id
   */
  deleteEducationProgram($id: string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then( (confirm) => {
      if (confirm === true) {

        this.adminService.apiDeleteEducationProgram($id).pipe(catchError(this.adminService.handleError('apiDeleteEducationProgram', false))).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataRemoved);
            this.configTable.reloadListener.next(true);
          }

        });

      }
    }).catch( (error) => {

    });

  }

  /**
   * Event button handler
   *
   * Handles output event of table when user triggers button
   *
   * @param $event
   */
  handleButtonEvent($event:any) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'edit':
          this.updateEducationProgram($event['data']);
          break;

        case 'delete':
          this.deleteEducationProgram($event['data']['id']);
          break;
      }
    }

  }

}
